import { OperationData } from "../../data/operationData";
import { AccountStatementData } from "../../data/accountStatementData";
import { CardStatementData } from "../../data/cardStatementData";
import { OperationRequestData } from "../../data/operationRequestData";
import { CatalogData } from "../../data/catalogData";
import { RequestParamsModel } from "../../models/statement/requestParamsModel";
import { CreditScheduleModel } from "../../models/schedule/creditScheduleModel";
import { clientTime } from "../../utilities/index";
import urlFilter from "../../filters/url.filter";
import { Http } from "./http";
import { OperationsApi } from "./OperationsApi";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";

/**Запросы к методам провередния операций дбо*/
export class OperationsHistoryApi {
  /**
   * Получение списка истории операций с поддержкой фильтра.
   * @param take Кол-во выборки.
   * @param skip Кол-во пропущенных с 0
   * @param dateBegin Дата начала выборки.
   * @param dateEnd Дата окончания выборки.
   * @param contractId Внутренний ИД счёта.
   * @param catalogType Тип каталога.
   * @param filter Тип фильтра.
   * @param searchText Поиск по тексту операции.
   * @returns Список истории операций ДБО
   */
  static async getOperationsHistory(
    params: RequestParamsModel
  ): Promise<Array<OperationData>> {
    const operationsList: Array<OperationData> = [];

    const respData = await Http.get(
      `WebClient/GetOperationsByFilter?contractId=${params.contractId > 0 ? params.contractId : null
      }&catalogType=${params.catalogType}&filter=${params.filter > 0 ? params.filter : ""
      }&take=${params.take}&skip=${params.skip}&dateBegin=${params.dateBegin
      }&dateEnd=${params.dateEnd
      }&clientTime=${clientTime()}&searchText=${params.searchText ?? ""}&typeSource=0`
    );

    const operations = respData?.data;

    if (operations != null) {
      operations.forEach((operation: any) => {
        operationsList.push(new OperationData(operation));
      });
    }
    return operationsList;
  }

   /**
   * Получение списка истории операций с поддержкой фильтра.
   * @param take Кол-во выборки.
   * @param skip Кол-во пропущенных с 0
   * @param dateBegin Дата начала выборки.
   * @param dateEnd Дата окончания выборки.
   * @param contractId Внутренний ИД счёта.
   * @param catalogType Тип каталога.
   * @param filter Тип фильтра.
   * @param searchText Поиск по тексту операции.
   * @returns Список истории операций ДБО
   */
  static async getOperationsList(
    params: RequestParamsModel
  ): Promise<Array<OperationData>> {
    const operationsList: Array<OperationData> = [];

    const respData = await Http.get(
      `WebClient/GetOperations?contractId=${params.contractId > 0 ? params.contractId : null
      }&catalogType=${params.catalogType}&filter=${params.filter > 0 ? params.filter : ""
      }&take=${params.take}&skip=${params.skip}&dateBegin=${params.dateBegin
      }&dateEnd=${params.dateEnd
      }&clientTime=${clientTime()}&searchText=${params.searchText ?? ""}&typeSource=0`
    );

    const operations = respData?.data;

    if (operations != null) {
      operations.forEach((operation: any) => {
        operationsList.push(new OperationData(operation));
      });
    }
    return operationsList;
  }

  /**
   * Получение списка операций в счёте.
   * @param contractId ИД счёта.
   * @param take Желаемое количество получить операций.
   * @param skip Количество сначала пропущенных операций.
   * @param sortType Тип сортировки, где 0 - по возрастанию даты, 1 - по убыванию даты.
   * @param dateBegin Фильтр : Дата начала выборки операций в счёте.
   * @param dateEnd Фильтр : Дата окончания выборки операций в счёте.
   */
  static async getAccountStatement(
    params: RequestParamsModel
  ): Promise<AccountStatementData> {
    // запрос - ответ
    const respData = await Http.get(
      `WebClient/FillList?take=${params.take}&skip=${params.skip}&sortType=${params.sortType
      }&respondentName=AccountStatement&dateBegin=${params.dateBegin}&dateEnd=${params.dateEnd
      } 23:59:59&contractId=${params.contractId}&clientTime=${clientTime()}&typeSource=0`
    );
    return new AccountStatementData(respData?.data);
  }

  /**
   * Получение списка операций в счёте.
   * @param contractId ИД счёта.
   * @param take Желаемое количество получить операций.
   * @param skip Количество сначала пропущенных операций.
   * @param sortType Тип сортировки, где 0 - по возрастанию даты, 1 - по убыванию даты.
   * @param dateBegin Фильтр : Дата начала выборки операций в счёте.
   * @param dateEnd Фильтр : Дата окончания выборки операций в счёте.
   */
  static async getCreditSchedule(
    params: RequestParamsModel
  ): Promise<CreditScheduleModel> {
    // запрос - ответ
    const respData = await Http.get(
      `WebClient/FillList?take=${params.take}&skip=${params.skip}&sortType=${params.sortType
      }&respondentName=GetCreditContractSchedule&dateBegin=${params.dateBegin
      }&dateEnd=${params.dateEnd} 23:59:59&contractId=${params.contractId
      }&clientTime=${clientTime()}&typeSource=0`
    );
    return new CreditScheduleModel(respData?.data?.Data);
  }

  /**
   * Получение списка операций в карте.
   * @param take Желаемое количество получить операций.
   * @param skip Количество сначала пропущенных операций.
   * @param sortType Тип сортировки, где 0 - по возрастанию даты, 1 - по убыванию даты.
   * @param dateBegin Фильтр : Дата начала выборки операций в счёте.
   * @param dateEnd Фильтр : Дата окончания выборки операций в счёте.
   * @param cardId ИД карты.</param
   */
  static async getCardStatement(
    params: RequestParamsModel
  ): Promise<CardStatementData> {
    const respData = await Http.get(
      `WebClient/FillList?take=${params.take}&skip=${params.skip}&sortType=${params.sortType
      }&respondentName=CardStatement&dateBegin=${params.dateBegin}&dateEnd=${params.dateEnd
      } 23:59:59&contractId=${params.contractId}&clientTime=${clientTime()}&typeSource=0`
    );
    return new CardStatementData(respData?.data);
  }

  /**
   * Получение операции.
   * @param id ИД операции.
   * @param refId ИД входящей операции.
   * @returns Данные операции.
   */
  static async getOperationAsync(
    id: number,
    refId: string
  ): Promise<OperationRequestData> {
    const respData = await Http.get(
      `WebClient/GetOperation?id=${id}&refId=${refId}&clientTime=${clientTime()}&typeSource=0`
    );
    return new OperationRequestData(respData?.data);
  }

  /**
   *  Получение данных операции.
   * @param id ИД операции в каталоге.
   * @returns Данные операции.
   */
  static async getRespondentAsync(id: number): Promise<CatalogData> {
    const respData = await Http.get(
      `WebClient/GetRespondent?operationId=${id}&clientTime=${clientTime()}&typeSource=0`
    );
    return new CatalogData(respData?.data);
  }

  static async getHistoryPdf(ord: OperationRequestData): Promise<string> {
    const respData = await Http.operationSendAsync(
      "Contract/GetHistoryPdf",
      ord
    );

    return urlFilter(respData?.data || "");
  }

  /**
* Запрос квитанции в pdf
* @param id идентификатор операции
* @returns ссылка на pdf
*/
  static async getOperationPdfAsync(id: string): Promise<string> {
    const data: FormData = new FormData();
    data.append("id", id.toString());
    data.append("respCode", '');
    data.append("useDraftTmp", '0');
    const respData = await Http.post(
      "/Operations/GetDetailsPdf", data
    );
    return urlFilter(respData?.data ?? '');
  }

  static async sendOperationCheckForEmail(operationId: string, email: string, respCode: string): Promise<void> {
    if (email) {
      const respData = await Http.get(
        `/Operations/SendMessage?operationId=${operationId}&email=${email}&clientTime=${clientTime()}&respCode=${respCode}&useDraftTmp=0&typeSource=0`
      );
    }
  }

  /**
* Запрос страницы квитанцией
* @param id идентификатор операции
* @returns ссылка на страницу
*/
  static async getOperDetailsHtml(id: string): Promise<string> {
    const respData = await Http.htmlSend(`/Operations/Print/${id}`, true, null);
    return respData;
  }

  /**
  * Запрос pdf
  * @param id идентификатор операции
  * @returns ссылка на pdf
  */
  static async getHtmlToPdfConvertAsync(html: string, contractName: string): Promise<string> {
    const ord: OperationRequestData = new OperationRequestData();
    ord.respondentCode = "ConvertHtmlToPdf";
    ord.setProperty(
      "html",
      html,
      DeclarationPropertiesTypes.String
    );
    ord.setProperty(
      "contractName",
      contractName,
      DeclarationPropertiesTypes.String
    );

    const respData = await OperationsApi.operationSendAsync(
      "/Contract/GetHistoryPdf", ord
    );

    return urlFilter(respData?.data ?? '');
  }

}
